/* Nothing Legal: recently viewed products.
 * Records the current product handle in localStorage and, wherever a
 * #recently-viewed container exists, renders the last few as compact cards.
 */
(function () {
  var KEY = "nl_recent";

  function get() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { return []; }
  }
  function set(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
  }

  function money(cents) {
    return window.theme.formatMoney(cents);
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  }

  var current = window.theme && window.theme.viewedHandle;

  // Record current product (most-recent first, deduped, capped at 8).
  if (current) {
    var list = get().filter(function (h) { return h !== current; });
    list.unshift(current);
    set(list.slice(0, 8));
  }

  function render() {
    var container = document.getElementById("recently-viewed");
    if (!container) return;
    var grid = container.querySelector("[data-rv-grid]");
    if (!grid) return;

    var handles = get().filter(function (h) { return h !== current; }).slice(0, 4);
    if (!handles.length) return;

    Promise.all(handles.map(function (h) {
      return fetch(window.theme.url("products/" + encodeURIComponent(h) + ".js"), { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || "";
        return '<a href="' + esc(p.url) + '" class="rv-card">' +
                 '<span class="rv-thumb">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '">' : "") + "</span>" +
                 '<span class="rv-title">' + esc(p.title) + "</span>" +
                 '<span class="rv-price">' + esc(money(p.price)) + "</span>" +
               "</a>";
      }).join("");
      if (html) {
        grid.innerHTML = html;
        container.style.display = "";
      }
    });
  }

  if (document.readyState !== "loading") render();
  else document.addEventListener("DOMContentLoaded", render);
})();
